export default {
  setOnlineMemberCount (state, { count }) {
    state.onlineMemberCount = count
  },
}
